/* eslint-disable import/prefer-default-export */
import { kebabCase } from 'lodash';

/**
 * Generates a unique ID for a block
 * @param {Object} block - A block object
 * @param {string} block._key - The block's _key
 * @param {string} block._type - The block's _type
 *
 * @example <Container {...generateSectionId(block)}>
 * @returns {Object} - An object with an id and as property
 */

export function generateSectionId(block) {
  const { _key, _type } = block;

  if (!_key || !_type)
    throw new Error('Block must have _key and _type properties');

  return {
    id: `${kebabCase(_type)}_${_key}`,
    as: 'section',
  };
}
